export default (array) => {
    return array.filter(val => typeof val === "string" ).join(' ');
}
